import React, {useState, useEffect, useContext} from "react";
import AdminListPage from '../administration/components/AdminListPage';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";



export default function AdministrationClassifications(){
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};

	return (
		<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
			<AdminListPage
					title="Classifications"
					headerTitle="Name"
					headerDescription="Description"
					restUrl="adminlistclassifications"
					adminPage="administrationclassificationsedit"
					downloadUrl="spreadsheetexportclassificationanditem"
					uploadUrl="spreadsheetimportclassificationanditem"
				/>
			</div>
	
	);
}